import React, { memo } from 'react';
import PdfThumbnail from './PdfThumbnail';

// Memoized version of PdfThumbnail that only re-renders when the URL changes
const MemoizedPdfThumbnail = memo(({ url }) => {
  return <PdfThumbnail url={url} />;
}, (prevProps, nextProps) => {
  // Only re-render if the URL changes
  return prevProps.url === nextProps.url;
});

export default MemoizedPdfThumbnail;
